import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  // プロパティ
  state() {
    return {
      email: '',
      token: '',
      item: [],
      reserveDate: '',
      reserveFromTime: [],
      reserveToTime: [],
      personNum: '',
      visiters: [],
      memo: '',
      personalName: '',
      birth: '',
      prefectures: '',
      city: '',
      gender: '',
      phoneNumber: '',
      formatPhoneNumber: '',
      password: '',
      companyName: '',
      isLoginFlag: false,
      isTokenError: false,
    }
},
  // アクセサ
  getters: {
    email (state) {
      return state.email;
    },
    token (state) {
      return state.token;
    },
    item (state) {
      return state.item;
    },
    reserveDate (state) {
      return state.reserveDate;
    },
    reserveFromTime (state) {
      return state.reserveFromTime;
    },
    reserveToTime (state) {
      return state.reserveToTime;
    },
    personNum (state) {
      return state.personNum;
    },
    visiters (state) {
      return state.visiters;
    },
    memo (state) {
      return state.memo;
    },
    personalName (state) {
      return state.personalName;
    },
    birth (state) {
      return state.birth;
    },
    gender (state) {
      return state.gender;
    },
    phoneNumber (state) {
      return state.phoneNumber;
    },
    formatPhoneNumber (state) {
      return state.formatPhoneNumber;
    },
    password (state) {
      return state.password;
    },
    companyName (state) {
      return state.companyName;
    },
    isLoginFlag (state) {
      return state.isLoginFlag;
    },
    isTokenError (state) {
      return state.isTokenError;
    },
    prefectures (state) {
      return state.prefectures;
    },
    city (state) {
      return state.city;
    }
  },
  // setter（stateを変更する場合はここに定義する）
  mutations: {
    setEmail (state, email) {
      state.email = email;
    },
    setToken (state, token) {
      state.token = token;
    },
    setItem (state, item) {
      state.item = item;
    },
    setReserveDate (state, reserveDate) {
      state.reserveDate = reserveDate;
    },
    setReserveFromTime (state, reserveFromTime) {
      state.reserveFromTime = reserveFromTime;
    },
    setReserveToTime (state, reserveToTime) {
      state.reserveToTime = reserveToTime;
    },
    setPersonNum (state, personNum) {
      state.personNum = personNum;
    },
    setVisiters (state, visiters) {
      state.visiters = visiters;
    },
    setMemo (state, memo) {
      state.memo = memo;
    },
    setPersonalName (state, personalName) {
      state.personalName = personalName
    },
    setBirth (state, birth) {
      state.birth = birth;
    },
    setGender (state, gender) {
      state.gender = gender;
    },
    setPhoneNumber (state, phoneNumber) {
      state.phoneNumber = phoneNumber;
    },
    setFormatPhoneNumber (state, formatPhoneNumber) {
      state.formatPhoneNumber = formatPhoneNumber;
    },
    setPassword (state, password) {
      state.password = password;
    },
    setCompanyName (state, companyName) {
      state.companyName = companyName;
    },
    setLoginFlag (state, isLoginFlag) {
      state.isLoginFlag = isLoginFlag;
    },
    setTokenError (state, isTokenError) {
      state.isTokenError = isTokenError;
    },
    setPrefectures (state, prefectures) {
      state.prefectures = prefectures;
    },
    setCity (state, city) {
      state.city = city;
    }

  },
  actions: {
    updateEmail ({ commit }, email) {
      commit('setEmail', email);
    },
    updateToken ({ commit }, token) {
      commit('setToken', token);
    },
    updateItem ({ commit }, item) {
      commit('setItem', item);
    },
    updateReserveDate ({ commit }, reserveDate) {
      commit('setReserveDate', reserveDate);
    },
    updateReserveFromTime ({ commit }, reserveFromTime) {
      commit('setReserveFromTime', reserveFromTime);
    },
    updateReserveToTime ({ commit }, reserveToTime) {
      commit('setReserveToTime', reserveToTime);
    },
    updatePersonNum ({ commit }, personNum) {
      commit('setPersonNum', personNum);
    },
    updateVisiters ({ commit }, visiters) {
      commit('setVisiters', visiters);
    },
    updateMemo ({ commit }, memo) {
      commit('setMemo', memo);
    },
    updatePersonalName ({ commit }, personalName) {
      commit('setPersonalName', personalName)
    },
    updateBirth ({ commit }, birth) {
      commit('setBirth', birth)
    },
    updateGender ({ commit }, gender) {
      commit('setGender', gender)
    },
    updatePhoneNumber ({ commit }, phoneNumber) {
      commit('setPhoneNumber', phoneNumber)
    },
    updateFormatPhoneNumber ({ commit }, formatPhoneNumber) {
      commit('setFormatPhoneNumber', formatPhoneNumber)
    },
    updatePassword ({ commit }, password) {
      commit('setPassword', password)
    },
    updateCompanyName ({ commit }, companyName) {
      commit('setCompanyName', companyName)
    },
    updateLoginFlag ({ commit }, isLoginFlag) {
      commit('setLoginFlag', isLoginFlag)
    },
    updateTokenError ({ commit }, isTokenError) {
      commit('setTokenError', isTokenError)
    },
    updatePrefectures ({ commit }, prefectures) {
      commit('setPrefectures', prefectures)
    },
    updateCity ({ commit }, city) {
      commit('setCity', city)
    },
    clearItem ({ commit }) {
      commit('setItem', []);
    },
    clearReserveDate ({ commit }) {
      commit('setReserveDate', '');
    },
    clearReserveTimes ({ commit }) {
      commit('setReserveFromTime', []);
      commit('setReserveToTime', []);
    },
    clearPersonNum ({ commit }) {
      commit('setPersonNum', '');
    },
    clearVisiters ({ commit }) {
      commit('setVisiters', []);
    },
    clearToken ({ commit }) {
      commit('setToken', '');
    },
    clearMemo ({ commit }) {
      commit('setMemo', '');
    },
    clearPersonalName ({ commit }) {
      commit('setPersonalName', '');
    },
    clearBirth ({ commit }) {
      commit('setBirth', '');
    },
    clearGender ({ commit }) {
      commit('setGender', '');
    },
    clearPhoneNumber ({ commit }) {
      commit('setPhoneNumber', '');
    },
    clearFormatPhoneNumber ({ commit }) {
      commit('setFormatPhoneNumber', '');
    },
    clearEmail ({ commit }) {
      commit('setEmail', '');
    },
    clearPassword ({ commit }) {
      commit('setPassword', '');
    },
    clearCompanyName ({ commit }) {
      commit('setCompanyName', '');
    },
    clearLoginFlag ({ commit }) {
      commit('setLoginFlag', false);
    },
    clearTokenError ({ commit }) {
      commit('setTokenError', false);
    },
    clearPrefectures ({ commit }) {
      commit('setPrefectures', '');
    },
    clearCity ({ commit }) {
      commit('setCity', '');
    },
    clearAll ({ commit }) {
      commit('setItem', []);
      commit('setReserveDate', '');
      commit('setReserveFromTime', []);
      commit('setReserveToTime', []);
      commit('setPersonNum', '');
      commit('setVisiters', []);
      commit('setToken', '');
      commit('setMemo', '');
      commit('setPersonalName', '');
      commit('setBirth', '');
      commit('setGender', '');
      commit('setPhoneNumber', '');
      commit('setFormatPhoneNumber', '');
      commit('setEmail', '');
      commit('setPassword', '');
      commit('setCompanyName', '');
      commit('setLoginFlag', false);
      commit('setPrefectures', '');
      commit('setCity', '');
    }
  },
  modules: {
  },
  plugins: [createPersistedState({ paths: ['token', 'email', 'isLoginFlag'] })],
})
